import { useState, useCallback } from 'react'
import type { AutosuggestProps } from '@cloudscape-design/components/autosuggest'
import { getCityPredictions, parseCityState } from '@/clients/google'

export function useCityAutocomplete() {
  const [inputValue, setInputValue] = useState('')
  const [options, setOptions] = useState<AutosuggestProps.Option[]>([])
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChange = useCallback(async (value: string) => {
    setInputValue(value)
    const manual = parseCityState(value)
    if (manual.city) { setCity(manual.city); setState(manual.state) }

    if (value.length < 2) { setOptions([]); return }
    setLoading(true)
    const predictions = await getCityPredictions(value)
    setOptions(predictions)
    setLoading(false)
  }, [])

  const handleSelect = useCallback((value: string) => {
    setInputValue(value)
    const parsed = parseCityState(value)
    setCity(parsed.city)
    setState(parsed.state)
    setOptions([])
  }, [])

  const reset = useCallback(() => {
    setInputValue('')
    setOptions([])
    setCity('')
    setState('')
  }, [])

  return { inputValue, options, city, state, loading, handleChange, handleSelect, reset }
}
